// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){ 

	$(document).ready(function () {
		$('body.sitemap').attr('id','default');

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$(".burger").click(function() {
			$(this).toggleClass('active');
			$('#primary-nav').toggleClass('active');
		    return false;
		});

		$(".language-btn").change(function(e){
			e.preventDefault()
			
			let langSel 	=$(this).val().toLowerCase();
			let pathname 	= document.location.pathname
			let origin 		= document.location.origin
			let langs 		= ['es','fr','de','pt','it']
			for (const key in langs) {
				if(pathname.indexOf(`/${langs[key]}/`)>-1)
					pathname = pathname.replace(`/${langs[key]}/`,'')
			}

			if(langSel!='en'){
				if($('body').attr('id')==='home')
					document.location = origin+'/'+langSel
				else{
					let newUrl =langSel+'/'+pathname
					newUrl = newUrl.replace('//','/')
					document.location = origin+'/'+newUrl
				}
			}else{
				if($('body').attr('id')==='home')
					document.location = origin+'/'
				else
					document.location = origin+'/'+pathname
			}

		});
	});   

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();

			let animatedEl = document.getElementsByClassName('animate');
			const h = window.innerHeight;
			var i;
			for (i = 0; i < animatedEl.length; i++) {
				var viewportOffset = animatedEl[i].getBoundingClientRect();
				let topPos = viewportOffset.top;
				//animatedEl[i].innerHTML = topPos;
				if(topPos <= h*0.8){
					animatedEl[i].classList.add('fade-in');
				}
			}
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}